<template>
	<div class="period-box">
		<InputText
			:inputClass="inputClass"
			@input="input($event, 'from')"
			:mode="mode"
			:prevLabel="fromPrevLabel"
			:nextLabel="fromNextLabel"
			:inputWidth="inputWidth"
			:propValue="from"
			:placeholder="fromPlaceholder"
			:comma="comma"
			:disabled="disabled"
			:useMinus="useMinus"
			@enter="$emit('enter')"
		/>
		<span class="period-box__divider">~</span>
		<InputText
			:inputClass="inputClass"
			@input="input($event, 'to')"
			:mode="mode"
			:prevLabel="toPrevLabel"
			:nextLabel="toNextLabel"
			:inputWidth="inputWidth"
			:propValue="to"
			:placeholder="toPlaceholder"
			:comma="comma"
			:disabled="disabled"
			:useMinus="useMinus"
			@enter="$emit('enter')"
		/>
	</div>
</template>

<script>
	import InputText from '@/components/InputText.vue';

	export default {
		name: 'PeriodBox',
		components: {
			InputText,
		},
		props: {
			inputClass: {
				type: String,
			},
			disabled: {
				default: false,
			},
			comma: {
				default: false,
			},
			mode: {
				required: true,
				type: String,
			},
			fromValue: {
				type: [String, Number, Object],
				default: '',
			},
			toValue: {
				type: [String, Number, Object],
				default: '',
			},
			fromPrevLabel: String,
			fromNextLabel: String,
			toPrevLabel: String,
			toNextLabel: String,
			inputWidth: {
				type: Number,
				default: 58,
			},
			fromPlaceholder: String,
			toPlaceholder: String,
			useMinus: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				from: this.fromValue,
				to: this.toValue,
			};
		},
		watch: {
			fromValue(newVal) {
				this.from = newVal;
			},
			toValue(newVal) {
				this.to = newVal;
			},
		},
		methods: {
			input(newValue, target) {
				this[target] = newValue;
				this.$emit('change', {
					from: this.from,
					to: this.to,
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.period-box {
		font-size: 0;
		font-weight: 400;

		.period-box__divider {
			display: inline-block;
			margin: 0 20px;
			vertical-align: middle;
			color: #303653;
			font-size: 0.875rem;
		}
	}
</style>
